import React, { Component } from 'react';
import '../../App.css';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { getPricing } from '../../actions/pay.js';
import { updatePaperInput, updateStep3, updateSpecialInstruction, updateSpecialInstructionFile } from '../../actions/paper.js';
import calculatePrice from '../../util/calculatePrice'
import Dropzone from 'react-dropzone';
import classname from 'classnames';
import { openExtraModal } from '../../actions/modals.js';

class Extras extends Component{
  constructor(props) {
    super(props);
  }
  updatePaper(e, type){
    this.props.dispatch(updateStep3(e,this.props.Paper.paper.extras));
    var data = calculatePrice(this.props.Paper);
  }
  render() {
    var active_ESL = classname({
      'extras-wrap': true,
      'extras-wrap-active': (this.props.Paper.paper.extras.indexOf('ESL') > -1)
    });
    var active_extraEditing = classname({
      'extras-wrap': true,
      'extras-wrap-active': (this.props.Paper.paper.extras.indexOf('ExtraEditing') > -1)
    });
    var active_Critiques = classname({
      'extras-wrap': true,
      'extras-wrap-active': (this.props.Paper.paper.extras.indexOf('Critiques') > -1)
    });
    var active_extraComments = classname({
      'extras-wrap': true,
      'extras-wrap-active': (this.props.Paper.paper.extras.indexOf('extraComments') > -1)
    });
    var active_Formatting = classname({
      'extras-wrap': true,
      'extras-wrap-active': (this.props.Paper.paper.extras.indexOf('Formatting') > -1)
    });
    var active_GradeMyPaper = classname({
      'extras-wrap': true,
      'extras-wrap-active': (this.props.Paper.paper.extras.indexOf('gradeMyPaper') > -1)
    });
    var active_plagiarism = classname({
      'extras-wrap': true,
      'extras-wrap-active': (this.props.Paper.paper.extras.indexOf('Plagiarism') > -1)
    });
    var active_CitationCorrection = classname({
      'extras-wrap': true,
      'extras-wrap-active': (this.props.Paper.paper.extras.indexOf('CitationCorrection') > -1)
    });
    return (
      <div className="extras-body">
        <ul className="extras_listing_checkout">
          <li onClick={this.updatePaper.bind(this, 'ESL')}>
            <p className="list_item has_tooltip_left" className={active_ESL}>
              ESL
              <span className="pull-right">Starting from $10</span>
            </p>
          </li>
          <li onClick={this.updatePaper.bind(this, 'ExtraEditing')}>
            <p className="list_item has_tooltip_left" className={active_extraEditing}>
              Extra Editing
              <span className="pull-right">Starting from $10</span>
            </p>
          </li>
          <li onClick={this.updatePaper.bind(this, 'extraComments')}>
            <p className="list_item has_tooltip_left" className={active_extraComments}>
              Extra Comments
              <span className="pull-right">Starting from $10</span>
            </p>
          </li>
          <li onClick={this.updatePaper.bind(this, 'Critiques')}>
            <p className="list_item has_tooltip_left" className={active_Critiques}>
              Critiques
              <span className="pull-right">Starting from $10</span>
            </p>
          </li>
          <li onClick={this.updatePaper.bind(this, 'Formatting')} >
            <p className="list_item has_tooltip_left" className={active_Formatting}>
              Formatting
              <span className="pull-right">Starting from $10</span>
            </p>
          </li>
          <li onClick={this.updatePaper.bind(this, 'CitationCorrection')} >
            <p className="list_item has_tooltip_left" className={active_CitationCorrection}>
              Citation Correction
              <span className="pull-right">Starting from $10</span>
            </p>
          </li>
          <li onClick={this.updatePaper.bind(this, 'Plagiarism')}>
            <p className="list_item has_tooltip_left" className={active_plagiarism}>
              Plagiarism Check
              <span className="pull-right">Starting from $10</span>
            </p>
          </li>
          <li onClick={this.updatePaper.bind(this, 'gradeMyPaper')}>
            <p className="list_item has_tooltip_left" className={active_GradeMyPaper}>
              <a className="info" href="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Lorem Ipsum"></a>
              Grade My Paper
              <span className="pull-right">Starting from $10</span>
            </p>
          </li>
        </ul>
      </div>
    )
  }
}


export default connect(
  ({Paper})=>({Paper})
)(Extras);



// WEBPACK FOOTER //
// ./src/components/steps/Extras.js